export default __webpack_public_path__ + "static/media/icons-bar-next-normal.93baf812.svg";